module.exports = "/assets/data/822d70d3604e43f731ad03fae3748c91-RM12.data.json";